<div class="widget-container" #UpsetChartDiv>
    <app-upset-chart
    [headerConfig]="item.config?.widget_header_config"
    [config]="config"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    >
    </app-upset-chart>
</div>